module.exports = __webpack_public_path__ + "img/banner.c8f90691.jpg";